import { ContactSection } from '@/components/contact-section'
import { Footer } from '@/components/footer'
import { useI18n } from '@/lib/i18n'
import { useResearchPageSeoHead } from '@/lib/research-page-seo-head'

const CONTACT_LANGUAGES = ['en', 'zh', 'tw', 'ja', 'ko', 'ar', 'es', 'fr'] as const

export function ContactPage() {
  const { language, t } = useI18n()
  useResearchPageSeoHead({
    pagePath: '/contact-us',
    contentLanguage: language,
    title: `${t('contact.title')} | Mentiss AI`,
    description: `${t('contact.title')}. ${t('ourVision.title')}.`,
    translatedLanguages: CONTACT_LANGUAGES,
  })

  return (
    <div className="min-h-screen bg-background text-foreground">
      <main lang={language === 'zh' ? 'zh-Hans' : language === 'tw' ? 'zh-Hant' : language}>
        <ContactSection />
      </main>
      <Footer />
    </div>
  )
}
